/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="#FFCBC6" fillOpacity="0.2" />
    <path
      opacity="0.8"
      d="M5 10L8.6535 14L15 6"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CircleCheckIcon = (props) => <Icon component={svg} {...props} />;

export default CircleCheckIcon;
